import { render, staticRenderFns } from "./MsisdnListField2.vue?vue&type=template&id=2ec7af42&"
import script from "./MsisdnListField2.vue?vue&type=script&lang=js&"
export * from "./MsisdnListField2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports